import { FC } from "react";

import { BaseModal } from "@/components/BaseModal";
import { PrimaryText } from "@/components/Typography/Styled";
import { MarketShipmentHistory } from "@/features/MarketShipmentHistory";

import { ShipmentModalPayload } from "./ShipmentsModal.types";

interface ShipmentsModal extends ShipmentModalPayload {
    onClose: () => void;
}

export const ShipmentsModal: FC<ShipmentsModal> = ({
    marketId,
    marketName,
    targetDate,
    onClose,
}) => {
    return (
        <BaseModal
            open
            onClose={onClose}
            actions={null}
            maskClosable
            title={"Історія доставок"}
            styles={{
                content: { minHeight: "200px" },
            }}
        >
            <PrimaryText>{marketName}</PrimaryText>

            <MarketShipmentHistory
                marketId={marketId}
                initialDate={targetDate}
            />
        </BaseModal>
    );
};
